import React, { useEffect, useState } from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend
} from 'chart.js';

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

const ProductionHoursBarChart = () => {
  const [data, setData] = useState([]);
  const [month, setMonth] = useState(new Date().getMonth());
  const [year, setYear] = useState(new Date().getFullYear());

  useEffect(() => {
    fetch(`/api/productionEvents?month=${month + 1}&year=${year}`)
      .then(res => res.json())
      .then(res => setData(res))
      .catch(err => console.error('❌ Error fetching production chart data:', err));
  }, [month, year]);

  const chartData = {
    labels: data.map(d => `Día ${d.day}`),
    datasets: [
      {
        label: 'Horas de producción',
        data: data.map(d => d.hours),
        backgroundColor: '#12B8B2',
      }
    ]
  };

  return (
    <div className="p-3">
      <h5>Horas de Producción por Día</h5>
      <div className="d-flex align-items-center mb-2" style={{ gap: '8px' }}>
        <select value={month} onChange={e => setMonth(Number(e.target.value))}>
          {Array.from({ length: 12 }, (_, i) => (
            <option key={i} value={i}>{new Date(0, i).toLocaleString('es', { month: 'long' })}</option>
          ))}
        </select>
        <input type="number" value={year} onChange={e => setYear(Number(e.target.value))} />
      </div>
      <Bar data={chartData} />
    </div>
  );
};

export default ProductionHoursBarChart;
